export const validateUrl = (url) => {
  try {
    new URL(url);
    return { isValid: true, error: null };
  } catch {
    return { isValid: false, error: 'Please enter a valid URL' };
  }
};

export const validateRequired = (value, fieldName) => {
  if (!value || value.trim() === '') {
    return { isValid: false, error: `${fieldName} is required` };
  }
  return { isValid: true, error: null };
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    return { isValid: false, error: 'Please enter a valid email address' };
  }
  return { isValid: true, error: null };
};

export const validateForm = (formData, validationRules) => {
  const errors = {};
  let isValid = true;

  Object.keys(validationRules).forEach(field => {
    const rule = validationRules[field];
    const value = formData[field];

    if (rule.required) {
      const requiredValidation = validateRequired(value, rule.label || field);
      if (!requiredValidation.isValid) {
        errors[field] = requiredValidation.error;
        isValid = false;
      }
    }

    if (rule.url && value) {
      const urlValidation = validateUrl(value);
      if (!urlValidation.isValid) {
        errors[field] = urlValidation.error;
        isValid = false;
      }
    }

    if (rule.email && value) {
      const emailValidation = validateEmail(value);
      if (!emailValidation.isValid) {
        errors[field] = emailValidation.error;
        isValid = false;
      }
    }

    if (rule.minLength && value && value.length < rule.minLength) {
      errors[field] = `${rule.label || field} must be at least ${rule.minLength} characters`;
      isValid = false;
    }

    if (rule.maxLength && value && value.length > rule.maxLength) {
      errors[field] = `${rule.label || field} must be less than ${rule.maxLength} characters`;
      isValid = false;
    }
  });

  return { isValid, errors };
};
